import clsx from 'clsx';
import PropTypes from 'prop-types';
import { FaCheck } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useAuth0 } from '@auth0/auth0-react';
import { TravelOptionTab, TravelTypes } from '../../../constants';
import useScrollToElement from '../../../hooks/useScrollToElement';
import Label from '../../Label';
import AddToCompare from '../AddToCompare';

const TravelOptionTabs = ({
  isScrollingNeeded,
  isInsideModal,
  handleTabChange,
  selectedTab,
  doEnableAgentTipsFeature,
  isCruiseInBrochure,
  itineraryId,
  travelOptionMode,
}) => {
  const router = useRouter();
  const { user: auth0user } = useAuth0();
  const disabledModes = (auth0user && auth0user.disabledModes) || [];
  const travelAgency = useSelector((state) => state.user.travelAgency || {});
  const selectedTabClasses = 'text-theme border-b-2 border-theme';
  const scrollElementRef = useScrollToElement({
    value: isScrollingNeeded,
  });
  const { enableFlights } = router.query;
  const brochureSettings = (travelAgency && travelAgency.settings
    && travelAgency.settings.brochureSettings) || {};
  const displayLabel = (brochureSettings.DisplayName || 'brochure').toLowerCase();
  const checkIsEnabled = (mode) => {
    if (disabledModes && disabledModes.length > 0 && disabledModes.indexOf(mode) !== -1) {
      return false;
    }
    return (mode === TravelTypes.flight && enableFlights === '')
    || !travelAgency
    || !travelAgency.tripkitEnabledTransportModes
    || travelAgency.tripkitEnabledTransportModes.indexOf(mode) !== -1;
  };
  return (
    <div className={clsx('md:pl-8 font-bold border-b-2', { 'pr-4': selectedTab === TravelOptionTab.CRUISE })}>
      <div className="inline-flex w-full justify-between items-center flex-wrap-reverse">
        <div className="grid grid-flow-col auto-cols-max gap-5">
          {travelOptionMode === TravelTypes.cruise && (
            <a
              onClick={() => { handleTabChange(TravelOptionTab.CRUISE); }}
              onKeyDown={() => { handleTabChange(TravelOptionTab.CRUISE); }}
              role="button"
              tabIndex="-4"
              className={clsx(selectedTab === TravelOptionTab.CRUISE && selectedTabClasses, 'py-4 w-24 text-center')}
            >
              Cruise
            </a>
          )}
          {!isInsideModal && (
            <>
              {checkIsEnabled(TravelTypes.flight) && (
              <a
                onClick={() => { handleTabChange(TravelOptionTab.FLIGHT); }}
                onKeyDown={() => { handleTabChange(TravelOptionTab.FLIGHT); }}
                role="button"
                tabIndex="-3"
                className={clsx(selectedTab === TravelOptionTab.FLIGHT && selectedTabClasses, 'py-4 w-24 text-center')}
              >
                Flight
              </a>
              )}
              {checkIsEnabled(TravelTypes.hotel) && (
              <a
                onClick={() => { handleTabChange(TravelOptionTab.HOTEL); }}
                onKeyDown={() => { handleTabChange(TravelOptionTab.HOTEL); }}
                role="button"
                tabIndex="-2"
                className={clsx(selectedTab === TravelOptionTab.HOTEL && selectedTabClasses, 'py-4 w-24 text-center')}
              >
                Hotel
              </a>
              )}
              {checkIsEnabled(TravelTypes.carrental) && (
              <a
                onClick={() => { handleTabChange(TravelOptionTab.GROUND); }}
                onKeyDown={() => { handleTabChange(TravelOptionTab.GROUND); }}
                role="button"
                tabIndex="-1"
                className={clsx(selectedTab === TravelOptionTab.GROUND && selectedTabClasses, 'py-4 w-24 text-center')}
                ref={scrollElementRef}
              >
                Car
              </a>
              )}
              {checkIsEnabled(TravelTypes.tour) && (
              <a
                onClick={() => { handleTabChange(TravelOptionTab.TOUR); }}
                onKeyDown={() => { handleTabChange(TravelOptionTab.TOUR); }}
                role="button"
                tabIndex="0"
                className={clsx(selectedTab === TravelOptionTab.TOUR && selectedTabClasses, 'py-4 w-24 text-center')}
                ref={scrollElementRef}
              >
                Tour
              </a>
              )}
              {travelAgency && travelAgency.searchbarTab
                && (!travelAgency.tripkitEnabledTransportModes
                    || travelAgency.tripkitEnabledTransportModes
                      .indexOf(TravelTypes.custom) > -1) ? (
                        <a
                          onClick={() => {
                            handleTabChange(TravelOptionTab.CUSTOM);
                          }}
                          onKeyDown={() => {}}
                          role="button"
                          tabIndex="0"
                          className={clsx(selectedTab === TravelOptionTab.CUSTOM && selectedTabClasses, 'py-4 w-24 text-center')}
                          ref={scrollElementRef}
                        >
                          {travelAgency.searchbarTab.displayName}
                        </a>
                ) : <></>}
              {(doEnableAgentTipsFeature) && (
                <a
                  onClick={() => { handleTabChange(TravelOptionTab.TIPS); }}
                  onKeyDown={() => { handleTabChange(TravelOptionTab.TIPS); }}
                  role="button"
                  tabIndex="0"
                  className={clsx(selectedTab === TravelOptionTab.TIPS && selectedTabClasses, 'py-4 w-24 text-center')}
                >
                  Agent tips
                </a>
              )}
            </>
          )}
        </div>

        <div className="grid grid-flow-col auto-cols-max gap-2 items-center">
          <Label text={`Added to ${displayLabel}`} level="theme" icon={<FaCheck />} doShow={isCruiseInBrochure} />
          <AddToCompare itineraryId={itineraryId} />
        </div>
      </div>
    </div>
  );
};

TravelOptionTabs.defaultProps = {
  selectedTab: undefined,
};

TravelOptionTabs.propTypes = {
  isScrollingNeeded: PropTypes.bool.isRequired,
  isInsideModal: PropTypes.bool.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  selectedTab: PropTypes.number,
  doEnableAgentTipsFeature: PropTypes.bool.isRequired,
  isCruiseInBrochure: PropTypes.bool.isRequired,
  travelOptionMode: PropTypes.number.isRequired,
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
export default TravelOptionTabs;
